export default {
  sm: `
    TECH TALK
  `
};
